import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  selectCurrentUserCompanyId,
  selectCurrentUserType,
} from '@reducers/currentUser/currentUserSelectors'
import {
  selectShellUserCompanyId,
  selectShellUserLenderId,
  selectShellUserType,
} from '@reducers/shellUser/shellUserSelectors'
import analytics from '@helpers/segmentAnalytics'

const useSignupPageView = name => {
  const currentUserCompanyId = useSelector(selectCurrentUserCompanyId)
  const shellUserCompanyId = useSelector(selectShellUserCompanyId)
  const shellUserLenderId = useSelector(selectShellUserLenderId)
  const shellUserUserType = useSelector(selectShellUserType)
  const currentUserUserType = useSelector(selectCurrentUserType)
  const companyId = shellUserCompanyId || currentUserCompanyId
  const userType = shellUserUserType || currentUserUserType

  return useEffect(() => {
    const payload = {
      company_id: companyId,
      lender_id: shellUserLenderId,
      user_type: userType,
    }
    analytics.page(name, payload)
  }, [companyId, shellUserLenderId, userType, name])
}

export default useSignupPageView
